@import 'src/global/train-colors';

svg path{
  fill: var(--train-color);
}
